var _rect, _path, _path2, _path3, _path4, _path5, _rect2, _rect3, _rect4, _rect5, _rect6, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedalhaFabula1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 260,
    viewBox: "0 0 214 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 213,
    height: 260,
    rx: 8,
    fill: "#ECE6F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.683 112.44C170.683 149.683 142.821 168.305 109.707 179.106C107.973 179.656 106.089 179.629 104.373 179.031C71.1787 168.305 43.3176 149.683 43.3176 112.44V60.2984C43.3176 58.3228 44.1563 56.4282 45.6491 55.0313C47.142 53.6344 49.1667 52.8496 51.2779 52.8496C67.1986 52.8496 87.0993 43.9111 100.95 32.589C102.637 31.2408 104.782 30.5 107 30.5C109.218 30.5 111.364 31.2408 113.05 32.589C126.98 43.9856 146.802 52.8496 162.722 52.8496C164.833 52.8496 166.858 53.6344 168.351 55.0313C169.844 56.4282 170.683 58.3228 170.683 60.2984V112.44Z",
    fill: "url(#paint0_linear_2162_30852)",
    stroke: "url(#paint1_linear_2162_30852)",
    strokeWidth: 3.91429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.41 74.2329L138.507 101.671L134.748 109.189L115.516 115.783L97.4548 109.214L93.0847 95.0132L95.8201 74.2241L104.704 72.6567L112.361 78.6733L112.631 78.8843L112.941 78.7417L126.254 72.6392L137.41 74.2329Z",
    fill: "#AD670B",
    stroke: "#100F11",
    strokeWidth: 1.12195
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0002 107.402C104.569 106.721 104.293 102.354 116.073 102.354C127.854 102.354 126.319 106.882 134.025 107.402L124.488 114.134L117.756 116.378L109.903 115.256L103.732 113.012L97.0002 107.402Z",
    fill: "#E7C566"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.877 80.9746L103.05 82.1476M130.028 80.9746L128.855 82.1476M111.261 92.7041V91.5312M120.645 92.7041V91.5312M120.645 102.088H111.261M115.953 102.088V106.78M136.597 74.4061C132.843 70.6527 126.979 70.6527 123.225 74.4061L120.879 76.752C117.615 76.2418 114.291 76.2418 111.026 76.752L108.681 74.4061C106.954 72.6018 104.581 71.5573 102.085 71.5023C99.5881 71.4473 97.1718 72.3863 95.3675 74.1129C93.5632 75.8394 92.5187 78.212 92.4637 80.7086C92.4087 83.2053 93.3478 85.6215 95.0743 87.4258C93.3964 90.0538 92.5014 93.1051 92.4938 96.223C92.4938 107.249 103.05 116.163 115.953 116.163C128.855 116.163 139.412 107.249 139.412 96.223C139.427 93.0652 138.531 89.9701 136.831 87.3085C140.35 83.5551 140.35 77.925 136.597 74.4061Z",
    stroke: "#100F11",
    strokeWidth: 4.6918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3906 103.475L101.513 110.373L101.588 110.616L101.821 110.72L106.58 112.834L107.102 117.008L107.118 117.14L107.191 117.25L110.413 122.083L108.248 129.664L105.007 139.387L81.7656 139.927L80.7236 133.676L80.6807 133.414L80.4492 133.281L76.7432 131.164L74.6084 120.489L77.7627 117.335L77.834 117.264L77.877 117.171L80.6484 111.072L87.1611 103.475H99.3906Z",
    fill: "#D1B309",
    stroke: "#100F11",
    strokeWidth: 1.12195
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80.1708,
    y: 134.329,
    width: 25.8049,
    height: 4.4878,
    fill: "#B58406",
    stroke: "#100F11",
    strokeWidth: 1.12195
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 77.9269,
    y: 126.476,
    width: 30.2927,
    height: 4.4878,
    fill: "#D19809",
    stroke: "#100F11",
    strokeWidth: 1.12195
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 79.0488,
    y: 111.89,
    width: 28.0488,
    height: 4.4878,
    fill: "#D19809",
    stroke: "#100F11",
    strokeWidth: 1.12195
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 84.6586,
    y: 104.037,
    width: 16.8293,
    height: 4.4878,
    fill: "#B58406",
    stroke: "#100F11",
    strokeWidth: 1.12195
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 90.2527,
    y: 130.89,
    width: 11.1427,
    height: 4.4878,
    transform: "rotate(-89.6421 90.2527 130.89)",
    fill: "#FFE100",
    stroke: "#100F11",
    strokeWidth: 1.12195
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3973 102.966H87.137C85.064 102.966 83.3835 104.646 83.3835 106.719C83.3835 108.792 85.064 110.473 87.137 110.473H98.3973C100.47 110.473 102.151 108.792 102.151 106.719C102.151 104.646 100.47 102.966 98.3973 102.966Z",
    stroke: "#100F11",
    strokeWidth: 3.75344,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M104.027 110.473H81.5069C79.4339 110.473 77.7534 112.154 77.7534 114.227C77.7534 116.3 79.4339 117.98 81.5069 117.98H104.027C106.1 117.98 107.781 116.3 107.781 114.227C107.781 112.154 106.1 110.473 104.027 110.473Z",
    stroke: "#100F11",
    strokeWidth: 3.75344,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5206 125.486H107.781C108.776 125.486 109.731 125.091 110.435 124.387C111.139 123.683 111.534 122.728 111.534 121.733C111.534 120.737 111.139 119.783 110.435 119.079C109.731 118.375 108.776 117.979 107.781 117.979H77.7534C76.758 117.979 75.8033 118.375 75.0994 119.079C74.3955 119.783 74 120.737 74 121.733C74 122.728 74.3955 123.683 75.0994 124.387C75.8033 125.091 76.758 125.486 77.7534 125.486H89.0137",
    stroke: "#100F11",
    strokeWidth: 3.75344,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5208 121.733C96.5208 119.66 94.8403 117.979 92.7674 117.979C90.6944 117.979 89.0139 119.66 89.0139 121.733V129.24C89.0139 131.313 90.6944 132.993 92.7674 132.993C94.8403 132.993 96.5208 131.313 96.5208 129.24V121.733Z",
    stroke: "#100F11",
    strokeWidth: 3.75344,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M105.904 125.486C106.9 125.486 107.854 125.882 108.558 126.586C109.262 127.29 109.658 128.244 109.658 129.24C109.658 130.235 109.262 131.19 108.558 131.894C107.854 132.598 106.9 132.993 105.904 132.993H79.6301C78.6347 132.993 77.68 132.598 76.9761 131.894C76.2722 131.19 75.8767 130.235 75.8767 129.24C75.8767 128.244 76.2722 127.29 76.9761 126.586C77.68 125.882 78.6347 125.486 79.6301 125.486",
    stroke: "#100F11",
    strokeWidth: 3.75344,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M102.151 132.993H83.3836C81.3106 132.993 79.6301 134.673 79.6301 136.746C79.6301 138.819 81.3106 140.5 83.3836 140.5H102.151C104.224 140.5 105.904 138.819 105.904 136.746C105.904 134.673 104.224 132.993 102.151 132.993Z",
    stroke: "#100F11",
    strokeWidth: 3.75344,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0327 202.136V222.5H79.2088L68.858 207.565H68.669V222.5H65.5966V202.136H68.4403L78.8011 217.091H78.9901V202.136H82.0327ZM86.2759 222.5V207.227H89.2489V222.5H86.2759ZM86.5543 205.189L88.881 200.605H92.0131L88.9308 205.189H86.5543ZM106.314 207.227L100.776 222.5H97.5938L92.0455 207.227H95.2372L99.1051 218.98H99.2642L103.122 207.227H106.314ZM115.171 222.808C113.666 222.808 112.37 222.487 111.283 221.844C110.203 221.194 109.367 220.283 108.777 219.109C108.194 217.929 107.902 216.547 107.902 214.963C107.902 213.399 108.194 212.02 108.777 210.827C109.367 209.634 110.189 208.702 111.243 208.033C112.304 207.363 113.543 207.028 114.962 207.028C115.824 207.028 116.659 207.171 117.468 207.456C118.276 207.741 119.002 208.188 119.645 208.798C120.288 209.408 120.795 210.2 121.167 211.175C121.538 212.143 121.723 213.319 121.723 214.705V215.759H109.583V213.531H118.81C118.81 212.749 118.651 212.056 118.333 211.453C118.015 210.843 117.567 210.363 116.99 210.011C116.42 209.66 115.751 209.484 114.982 209.484C114.147 209.484 113.417 209.69 112.794 210.101C112.178 210.505 111.701 211.036 111.363 211.692C111.031 212.341 110.865 213.047 110.865 213.81V215.55C110.865 216.571 111.044 217.439 111.402 218.155C111.767 218.871 112.274 219.418 112.924 219.795C113.573 220.167 114.332 220.352 115.201 220.352C115.764 220.352 116.278 220.273 116.742 220.114C117.206 219.948 117.607 219.703 117.945 219.378C118.283 219.053 118.542 218.652 118.721 218.175L121.534 218.682C121.309 219.51 120.905 220.236 120.321 220.859C119.745 221.476 119.019 221.956 118.144 222.301C117.275 222.639 116.284 222.808 115.171 222.808ZM127.995 202.136V222.5H125.022V202.136H127.995ZM147.091 202.136V222.5H144.009V205.219H143.889L139.017 208.401V205.457L144.098 202.136H147.091Z",
    fill: "#4C4452"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2162_30852",
    x1: 107,
    y1: 30.5,
    x2: 107,
    y2: 179.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F3CD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497066,
    stopColor: "#FFDE93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67FFB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2162_30852",
    x1: 107,
    y1: 30.5,
    x2: 107,
    y2: 179.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#804A01"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalhaFabula1);
export default __webpack_public_path__ + "static/media/Medalha_fabula_1.95bb25d5eef3ebecb0b0e8324f099133.svg";
export { ForwardRef as ReactComponent };